// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__2dKio","inputWrap":"styles_inputWrap__18qE1","input":"styles_input__28-1N"};